import { getStoredAuthToken } from "@/lib/auth-token";
import { downloadBlob } from "@/lib/download";
import { toFileNameSlug } from "@/lib/recording-file-name";
import { getApiBaseUrl } from "@/lib/runtime-config";

const REPORT_FILE_PREFIX = "interview-report";
const INTERVIEW_ID_SHORT_LENGTH = 8;
const HTTP_NOT_FOUND = 404;

type ReportDownloadFailure = { ok: false; reason: "unauthorized" | "not-found" | "failed" };
export type ReportDownloadResult = { ok: true } | ReportDownloadFailure;

export const REPORT_DOWNLOAD_ERROR_MESSAGES: Record<ReportDownloadFailure["reason"], string> = {
  unauthorized: "認証トークンが見つかりません。再度ログインしてください。",
  "not-found": "レポートはまだ生成されていません。評価完了から1〜2分後に再度お試しください。",
  failed: "レポートの取得に失敗しました。",
};

interface ReportTarget {
  candidateName: string | null;
  interviewId: string;
}

export function buildReportFileName(input: ReportTarget): string {
  const parts = [
    REPORT_FILE_PREFIX,
    toFileNameSlug(input.candidateName),
    input.interviewId.slice(0, INTERVIEW_ID_SHORT_LENGTH),
  ].filter((part): part is string => part !== null);
  return `${parts.join("_")}.pdf`;
}

export async function downloadInterviewReport(input: ReportTarget): Promise<ReportDownloadResult> {
  const token = getStoredAuthToken();
  if (!token) return { ok: false, reason: "unauthorized" };
  try {
    const response = await fetch(
      `${getApiBaseUrl()}/api/v1/admin/interviews/${input.interviewId}/report`,
      { headers: { authorization: `Bearer ${token}` } }
    );
    if (response.status === HTTP_NOT_FOUND) return { ok: false, reason: "not-found" };
    if (!response.ok) return { ok: false, reason: "failed" };
    downloadBlob(await response.blob(), buildReportFileName(input));
    return { ok: true };
  } catch {
    return { ok: false, reason: "failed" };
  }
}
